import { withTranslation } from "react-i18next";
import InfoIcon from "../../assets/images/Icons/information_sessionexpire.svg";


const NotAvailable = (props) => {
    const containerStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: 'linear-gradient(168deg, #cbcbcb 0.33%, #fdfdfd 52.3%, #fff 97.77%)',
        color: '#4f4e4e !important',
        '@media (max-width: 850px)': {
            width: '100vw',
            padding: 20
        }
    };

    const messageStyle = {
        textAlign: 'center',
        '@media (max-width: 850px)': {
            width: '100vw',
            padding: 20,

        }
    };
    const message_heading = {
        background: 'none',
        display: 'flex',
        gap: '15px',
        alignItems: 'center',
        justifyContent: "center",
        fontSize: '24px',
        fontWeight: 'bold',
        color: "4f4e4e !important",
        marginBottom: 10,
        '@media (max-width: 850px)': {
            width: '100vw',
            padding: 20
        }
    }
    const message_heading2 = {

        '@media (max-width: 850px)': {
            width: '100vw',
            padding: 20,
            marginTop: 10,
            fontSize: 16
        }
    }
    const message_heading4 = {
        padding: 5,
        marginTop: 10,
        '@media (max-width: 850px)': {
            width: '100vw',
            padding: 20,
            marginTop: 10
        }
    }
    const message_icon = {
        width: 24, boxShadow: '0 1px 1px rgba(0,0,0,0.8)', borderRadius: "50%"
    }

    return (
        <div style={containerStyle}>

            <div className="session_ex_message" >
                <h2 className="session_ex_head">
                    <img src={InfoIcon} alt="" className="session_ex_icon" />
                    INFORMATION
                </h2>
                <h3 className="session_ex_head3" style={message_heading2}>
                    {props.t("togel_game_not_available_for_client")}
                </h3>
            </div>
        </div>
    );
};

export default withTranslation()(NotAvailable);
